/**
 * Primary snag/activity photos: bounded box so portrait phone shots do not dominate a full page.
 * (Thread/PM images use PDF_INLINE_PHOTO_BOX.)
 */
export const PDF_PRIMARY_PHOTO_BOX = { maxW: 360, maxH: 280 };

export const PDF_INLINE_PHOTO_BOX = { maxW: 220, maxH: 200 };

/** Reply / PM note images in snag export */
export const PDF_PM_NOTE_PHOTO_BOX = { maxW: 180, maxH: 180 };

/**
 * Uniform scale so the drawn size fits inside maxW × maxH (pt), like typical audit PDF thumbnails.
 * @param {{ wPt: number, hPt: number, dataUrl: string }} loaded
 * @param {{ maxW: number, maxH: number }} box
 * @returns {{ wPt: number, hPt: number, dataUrl: string }}
 */
export function fitImageDrawSize(loaded, box) {
  const { wPt, hPt, dataUrl } = loaded;
  if (!wPt || !hPt) return { ...loaded, wPt: 0, hPt: 0 };
  const scale = Math.min(1, box.maxW / wPt, box.maxH / hPt);
  return { dataUrl, wPt: wPt * scale, hPt: hPt * scale };
}
